import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SEOHead from '../../../components/SEOHead';

export default function MaterialsPage() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [equipmentDropdownOpen, setEquipmentDropdownOpen] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [mobileEquipmentOpen, setMobileEquipmentOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [activeTab, setActiveTab] = useState('전체');

  const handleGoToSection = (sectionId: string) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const navLinks = [
    { href: null, label: '회사소개', type: 'dropdown', subMenu: [
      { href: null, label: '회사소개', scrollTo: 'about' },
      { href: '/history', label: '연혁', scrollTo: null },
      { href: '/organization', label: '조직도', scrollTo: null },
      { href: null, label: '오시는 길', scrollTo: 'map' },
    ]},
    { href: null, label: '생산공정', type: 'section', scrollTo: 'process' },
    { href: null, label: '보유장비', type: 'dropdown', subMenu: [
      { href: '/equipment/production', label: '생산장비', scrollTo: null },
      { href: '/equipment/welding', label: '용접장비', scrollTo: null },
      { href: '/equipment/capability', label: '가공능력', scrollTo: null },
      { href: '/equipment/materials', label: '가공 가능자재', scrollTo: null },
    ]},
    { href: null, label: '제조물품', type: 'dropdown', subMenu: [
      { href: '/gallery', label: '갤러리', scrollTo: null },
    ]},
  ];

  const tabs = ['전체', '철판', '스테인리스', '알루미늄', '기타'];

  const materials = [
    {
      category: '철판',
      tagColor: 'bg-gray-700',
      tagText: 'text-white',
      accentColor: 'border-gray-600',
      headerBg: 'bg-gradient-to-r from-gray-700 to-gray-600',
      icon: 'ri-stack-line',
      images: [
        'https://public.readdy.ai/ai/img_res/4690d3a5c6c9a1ca74557dc4057fda92.jpg',
        'https://readdy.ai/api/search-image?query=zinc%20coated%20galvanized%20steel%20coil%20roll%20shiny%20metallic%20surface%20industrial%20factory%20storage%20bright%20workshop%20lighting%20close%20up%20detail%20professional%20photography&width=600&height=400&seq=steel-plate-new-b2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=laser%20cutting%20machine%20processing%20flat%20steel%20iron%20plate%20sparks%20flying%20CNC%20precision%20cutting%20workshop%20dark%20background%20dramatic%20industrial%20scene%20professional%20photography&width=600&height=400&seq=steel-plate-new-c3&orientation=landscape',
      ],
      items: [
        { name: 'HR (SS41 or SS400)', desc: '일반적인 철판', tag: '범용' },
        { name: '코르텐강판', desc: '주로 외부 케이스 사용', tag: '내후성' },
        { name: 'CR 냉간압연강판', desc: '광범위하게 다양한 곳에 사용되는 철판, 주로 가구·인테리어·자동차·건축자재 등', tag: '정밀' },
        { name: 'EGI 갈바 아연도금강판', desc: '도장성이 우수하여 도장 마감이 중요한 분야에 사용, 주로 간판 글씨 주재료로 많이 사용', tag: '도장용' },
        { name: 'GI 용융아연도금강판', desc: '냉연강판 위에 녹 발생 방지를 위해 아연 피막을 입힌 강판, 주로 배수관·캠핑용품 제작에 사용', tag: '방청' },
      ],
    },
    {
      category: '스테인리스',
      tagColor: 'bg-slate-500',
      tagText: 'text-white',
      accentColor: 'border-slate-400',
      headerBg: 'bg-gradient-to-r from-slate-600 to-slate-500',
      icon: 'ri-contrast-2-line',
      images: [
        'https://readdy.ai/api/search-image?query=stainless%20steel%20STS%20304%202B%20mirror%20polished%20sheet%20metal%20plate%20shiny%20reflective%20silver%20surface%20industrial%20material%20clean%20smooth%20texture%20professional%20photography&width=600&height=400&seq=mat-sts304-001&orientation=landscape',
        'https://readdy.ai/api/search-image?query=stainless%20steel%20HL%20hairline%20finish%20brushed%20metal%20surface%20silver%20industrial%20material%20manufacturing%20workshop%20professional%20photography%20high%20detail&width=600&height=400&seq=mat-stshl-001&orientation=landscape',
        'https://readdy.ai/api/search-image?query=black%20stainless%20steel%20HL%20black%20coated%20metal%20sheet%20dark%20surface%20premium%20industrial%20material%20modern%20architecture%20interior%20professional%20photography&width=600&height=400&seq=mat-stsblack-001&orientation=landscape',
      ],
      items: [
        { name: 'STS 2B 304', desc: '주위에서 보이는 2B, 기본적인 스테인리스 (주방 및 수저·식기 등 여러 방면에서 널리 사용)', tag: '기본' },
        { name: 'STS 316', desc: '304 스텐 대비 크롬과 니켈 함유량 비율을 올려 보다 강한 내식성을 가진 스테인리스 (주로 해수 설비 및 의료용으로 사용)', tag: '내식성' },
        { name: 'STS 310', desc: '316 스텐 대비 크롬과 니켈 함유가 매우 높아 고온 환경에서도 안정성이 향상된 스테인리스 (주로 열처리·연소실·열교환기로 사용)', tag: '내열' },
        { name: 'STS 201', desc: '기본적인 스테인리스 대비 녹 발생 확률이 현저히 높으나 가격이 저렴하고 자석에 붙지 않는 특징 (주방 및 업소용 조리대로 사용)', tag: '경제형' },
        { name: 'STS 430', desc: '니켈이 포함되지 않아 기본 스테인리스 대비 내식성이 낮음, 가격이 저렴하여 가성비가 좋고 가공성이 우수 (캠핑 장비·주방 기구에 사용)', tag: '가성비' },
        { name: 'STS 1D', desc: '기본적 스테인리스 304 재질로 표면 마무리가 달라 겉으로 보면 무광색이 보이는 게 특징 (대형 탱크·파이프·건축 구조재에 사용)', tag: '무광' },
        { name: 'STS HL', desc: '304 스테인리스에 머리카락같이 긴 연마 자국 낸 소재, 고급스러우며 무광이 특징이며 스크래치가 잘 티 나지 않아 관리가 용이 (주방 기기·건축용 패널·제품 외관에 사용)', tag: '헤어라인' },
        { name: 'STS HL-BLACK', desc: '304 스테인리스 표면에 블랙 색상을 입힌 고급 금속 소재로서 심미성이 뛰어나 트렌드로 부상 중인 스테인리스 (건축 내외장재·간판·인테리어에 사용)', tag: '블랙' },
        { name: 'STS Polishing', desc: '표면을 거울처럼 매끄럽게 연마하여 우수한 광택 고급스러운 외관을 보이는 특징 (건축 내/외장재·주방 설비·인테리어에 사용)', tag: '우수한 광택' },
      ],
    },
    {
      category: '알루미늄',
      tagColor: 'bg-sky-500',
      tagText: 'text-white',
      accentColor: 'border-sky-400',
      headerBg: 'bg-gradient-to-r from-sky-600 to-sky-500',
      icon: 'ri-box-3-line',
      images: [
        'https://readdy.ai/api/search-image?query=aluminum%20alloy%206061%20metal%20plate%20sheet%20light%20silver%20surface%20smooth%20texture%20industrial%20material%20precision%20machined%20edge%20clean%20workshop%20environment%20professional%20photography%20high%20resolution&width=600&height=400&seq=mat-al6061-001&orientation=landscape',
        'https://readdy.ai/api/search-image?query=anodized%20aluminum%20sheet%20metal%20lightweight%20silver%20surface%20industrial%20manufacturing%20precision%20parts%20clean%20background%20professional%20photography&width=600&height=400&seq=mat-al-anodized-001&orientation=landscape',
        'https://readdy.ai/api/search-image?query=aluminum%20extrusion%20profile%20metal%20parts%20lightweight%20industrial%20material%20silver%20surface%20manufacturing%20workshop%20professional%20photography&width=600&height=400&seq=mat-al-extrusion-001&orientation=landscape',
      ],
      items: [
        { name: '6000번대 시리즈 6061', desc: '일반적으로 사용되는 재질로써 내식성·용접성·기계적 특성 및 강성이 우수하여 주로 광범위하게 널리 쓰임 (자동차 부품·저장 용기·금속 상자·주방용품에 사용)', tag: '범용' },
      ],
    },
    {
      category: '기타',
      tagColor: 'bg-amber-600',
      tagText: 'text-white',
      accentColor: 'border-amber-500',
      headerBg: 'bg-gradient-to-r from-amber-700 to-amber-600',
      icon: 'ri-copper-coin-line',
      images: [
        'https://readdy.ai/api/search-image?query=copper%20metal%20sheet%20plate%20reddish%20orange%20surface%20industrial%20material%20shiny%20texture%20manufacturing%20workshop%20professional%20photography%20high%20detail%20close%20up&width=600&height=400&seq=mat-copper-002&orientation=landscape',
        'https://readdy.ai/api/search-image?query=brass%20metal%20sheet%20plate%20golden%20yellow%20surface%20industrial%20material%20shiny%20texture%20manufacturing%20workshop%20professional%20photography%20high%20detail&width=600&height=400&seq=mat-brass-001&orientation=landscape',
        'https://readdy.ai/api/search-image?query=copper%20brass%20decorative%20metal%20material%20golden%20reddish%20surface%20artistic%20industrial%20use%20sign%20making%20interior%20design%20professional%20photography&width=600&height=400&seq=mat-copperbrass-001&orientation=landscape',
      ],
      items: [
        { name: '적동', desc: '구리 함량이 90% 이상으로 매우 높으며 표면이 붉은빛을 띠며 전도성·열전도율·연전성이 뛰어남 (열교환기·예술 조각품·간판에 사용)', tag: '구리' },
        { name: '황동(신주)', desc: '구리에 아연을 첨가하여 적동보다 내식성 및 강도가 높고 절삭 가공성이 좋음, 금속 특유의 고급스러운 금색을 표면에서 볼 수 있음 (조명 기구·인테리어 손잡이·장식품·간판에 사용)', tag: '황동' },
      ],
    },
  ];

  const filteredMaterials = activeTab === '전체' ? materials : materials.filter(m => m.category === activeTab);

  return (
    <>
      <SEOHead
        title="가공 가능자재 | NS-TECH 판금가공"
        description="NS-TECH가 가공 가능한 다양한 금속 소재. 철판, 스테인리스, 알루미늄, 구리, 황동 등 각종 금속 소재의 레이저 절단, 절곡, 용접 가공이 가능합니다."
        keywords="가공 가능 자재, 철판, 스테인리스, 알루미늄, 구리, 황동, 금속 소재, 판금 소재"
        ogType="website"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: 'NS-TECH 가공 가능 자재',
            description: '철판, 스테인리스, 알루미늄 등 다양한 금속 소재 가공',
            url: `${import.meta.env.VITE_SITE_URL}/equipment/materials`,
            itemListElement: materials.map((mat, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              item: {
                '@type': 'Product',
                name: mat.category,
                description: `${mat.items.length}가지 ${mat.category} 소재`,
              },
            })),
          },
        ]}
      />
      <div className="min-h-screen bg-white">
        {/* 네비게이션 */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
          <div className="w-full px-4 lg:px-8 py-3">
            <div className="flex items-center justify-between">
              <div className="hidden lg:flex items-center gap-2">
                <Link to="/" className="flex items-center gap-2 shrink-0 mr-2" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>
                  <img src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png" alt="NS-TECH Logo" className="h-12 w-auto object-contain" />
                </Link>
                {navLinks.map((link) => (
                  link.type === 'dropdown' ? (
                    <div key={link.label} className="relative"
                      onMouseEnter={() => {
                        if (link.label === '보유장비') setEquipmentDropdownOpen(true);
                        if (link.label === '제조물품') setProductsDropdownOpen(true);
                        if (link.label === '회사소개') setAboutDropdownOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (link.label === '보유장비') setEquipmentDropdownOpen(false);
                        if (link.label === '제조물품') setProductsDropdownOpen(false);
                        if (link.label === '회사소개') setAboutDropdownOpen(false);
                      }}
                    >
                      <button className={`text-sm font-medium transition-colors whitespace-nowrap px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer ${
                        link.label === '보유장비' ? 'text-orange-500 bg-orange-50' : 'text-gray-700 hover:text-orange-500 hover:bg-orange-50'
                      }`}>
                        {link.label}
                        <i className={`ri-arrow-down-s-line transition-transform ${
                          (link.label === '보유장비' && equipmentDropdownOpen) ||
                          (link.label === '제조물품' && productsDropdownOpen) ||
                          (link.label === '회사소개' && aboutDropdownOpen) ? 'rotate-180' : ''
                        }`}></i>
                      </button>
                      {((link.label === '보유장비' && equipmentDropdownOpen) ||
                        (link.label === '제조물품' && productsDropdownOpen) ||
                        (link.label === '회사소개' && aboutDropdownOpen)) && (
                        <div className="absolute top-full left-0 mt-1 bg-white shadow-lg rounded-lg py-2 min-w-[160px] border border-gray-100">
                          {link.subMenu?.map((subLink) => (
                            subLink.scrollTo ? (
                              <button key={subLink.label} onClick={() => handleGoToSection(subLink.scrollTo!)}
                                className="block w-full text-left px-4 py-2 text-sm hover:text-orange-500 hover:bg-orange-50 transition-colors whitespace-nowrap text-gray-700 cursor-pointer">
                                {subLink.label}
                              </button>
                            ) : (
                              <Link key={subLink.href} to={subLink.href!}
                                className={`block px-4 py-2 text-sm hover:text-orange-500 hover:bg-orange-50 transition-colors whitespace-nowrap ${
                                  subLink.href === '/equipment/materials' ? 'text-orange-500 font-semibold' : 'text-gray-700'
                                }`}>
                                {subLink.label}
                              </Link>
                            )
                          ))}
                        </div>
                      )}
                    </div>
                  ) : link.type === 'section' ? (
                    <button key={link.label} onClick={() => handleGoToSection((link as any).scrollTo)}
                      className="text-sm font-medium transition-colors whitespace-nowrap px-4 py-2 rounded-md text-gray-700 hover:text-orange-500 hover:bg-orange-50 cursor-pointer">
                      {link.label}
                    </button>
                  ) : (
                    <Link key={(link as any).href} to={(link as any).href}
                      className="text-sm font-medium transition-colors whitespace-nowrap px-4 py-2 rounded-md text-gray-700 hover:text-orange-500 hover:bg-orange-50">
                      {link.label}
                    </Link>
                  )
                ))}
              </div>
              <div className="flex lg:hidden items-center justify-between w-full">
                <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}><img src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png" alt="NS-TECH Logo" className="h-10 w-auto object-contain" /></Link>
                <button className="flex flex-col justify-center items-center w-10 h-10 gap-1.5 cursor-pointer relative z-[60]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="메뉴 열기">
                  <span className={`block w-6 h-0.5 transition-all duration-300 bg-gray-800 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                  <span className={`block w-6 h-0.5 transition-all duration-300 bg-gray-800 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
                  <span className={`block w-6 h-0.5 transition-all duration-300 bg-gray-800 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </button>
              </div>
              <div className="hidden lg:flex items-center">
                <button onClick={() => setShowContactModal(true)}
                  className="text-sm font-medium transition-colors whitespace-nowrap px-4 py-2 rounded-md text-gray-700 hover:text-orange-500 hover:bg-orange-50 cursor-pointer">
                  고객지원
                </button>
              </div>
            </div>
          </div>
          <div className={`lg:hidden fixed inset-0 bg-black/50 transition-opacity duration-300 z-40 ${mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} onClick={() => setMobileMenuOpen(false)}></div>
          <div className={`lg:hidden fixed top-[60px] left-0 right-0 transition-all duration-300 ease-in-out z-50 ${mobileMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`}>
            <div className="bg-white shadow-xl border-t border-gray-100 px-5 py-3 flex flex-col gap-1">
              {navLinks.map((link) => (
                link.type === 'dropdown' ? (
                  <div key={link.label}>
                    <button onClick={() => {
                      if (link.label === '보유장비') setMobileEquipmentOpen(!mobileEquipmentOpen);
                      if (link.label === '제조물품') setMobileProductsOpen(!mobileProductsOpen);
                      if (link.label === '회사소개') setMobileAboutOpen(!mobileAboutOpen);
                    }} className="w-full text-sm font-medium py-2.5 px-4 rounded-lg transition-all cursor-pointer text-left text-gray-700 hover:text-orange-500 hover:bg-orange-50 flex items-center justify-between">
                      {link.label}
                      <i className={`ri-arrow-down-s-line transition-transform ${
                        (link.label === '보유장비' && mobileEquipmentOpen) ||
                        (link.label === '제조물품' && mobileProductsOpen) ||
                        (link.label === '회사소개' && mobileAboutOpen) ? 'rotate-180' : ''
                      }`}></i>
                    </button>
                    {((link.label === '보유장비' && mobileEquipmentOpen) ||
                      (link.label === '제조물품' && mobileProductsOpen) ||
                      (link.label === '회사소개' && mobileAboutOpen)) && (
                      <div className="pl-4 mt-1 space-y-1">
                        {link.subMenu?.map((subLink) => (
                          subLink.scrollTo ? (
                            <button key={subLink.label} onClick={() => { setMobileMenuOpen(false); handleGoToSection(subLink.scrollTo!); }}
                              className="block w-full text-left text-sm font-medium py-2 px-4 rounded-lg transition-all cursor-pointer text-gray-600 hover:text-orange-500 hover:bg-orange-50">
                              {subLink.label}
                            </button>
                          ) : (
                            <Link key={subLink.href} to={subLink.href!} onClick={() => setMobileMenuOpen(false)}
                              className="block text-sm font-medium py-2 px-4 rounded-lg transition-all cursor-pointer text-gray-600 hover:text-orange-500 hover:bg-orange-50">
                              {subLink.label}
                            </Link>
                          )
                        ))}
                      </div>
                    )}
                  </div>
                ) : link.type === 'section' ? (
                  <button key={link.label} onClick={() => { setMobileMenuOpen(false); handleGoToSection((link as any).scrollTo); }}
                    className="text-sm font-medium py-2.5 px-4 rounded-lg transition-all cursor-pointer text-left text-gray-700 hover:text-orange-500 hover:bg-orange-50">
                    {link.label}
                  </button>
                ) : (
                  <Link key={(link as any).href} to={(link as any).href} onClick={() => setMobileMenuOpen(false)}
                    className="text-sm font-medium py-2.5 px-4 rounded-lg transition-all cursor-pointer text-gray-700 hover:text-orange-500 hover:bg-orange-50">
                    {link.label}
                  </Link>
                )
              ))}
              <button onClick={() => { setMobileMenuOpen(false); setShowContactModal(true); }}
                className="w-full text-sm font-medium py-2.5 px-4 rounded-lg transition-all cursor-pointer text-left text-gray-700 hover:text-orange-500 hover:bg-orange-50">
                고객지원
              </button>
            </div>
          </div>
        </nav>

        {/* 히어로 섹션 */}
        <div className="relative pt-[60px] h-64 md:h-80 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=various%20metal%20materials%20steel%20stainless%20aluminum%20copper%20brass%20sheet%20plates%20industrial%20manufacturing%20workshop%20organized%20display%20professional%20photography%20wide%20angle&width=1400&height=500&seq=mat-hero-001&orientation=landscape"
            alt="가공 가능 자재"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/20"></div>
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-20">
            <span className="text-orange-400 text-xs font-bold uppercase tracking-widest mb-2">Materials</span>
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 drop-shadow-lg">가공 가능 자재</h1>
            <p className="text-sm md:text-lg text-white/80 max-w-xl">NS-TECH가 직접 작업하고 가공 가능한 다양한 금속 소재를 안내합니다</p>
          </div>
        </div>

        {/* 카테고리 탭 */}
        <div className="sticky top-[60px] z-40 bg-white border-b border-gray-200 shadow-sm">
          <div className="max-w-6xl mx-auto px-4 md:px-8 py-3">
            <div className="flex gap-2 overflow-x-auto scrollbar-hide">
              {tabs.map((tab) => (
                <button key={tab} onClick={() => setActiveTab(tab)}
                  className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ${
                    activeTab === tab ? 'bg-orange-500 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}>
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* 자재 목록 */}
        <section className="py-12 md:py-16 px-4 md:px-8 bg-gray-50">
          <div className="max-w-6xl mx-auto space-y-12">
            {filteredMaterials.map((mat, idx) => (
              <div key={idx} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300">
                {/* 카테고리 헤더 */}
                <div className={`${mat.headerBg} px-6 py-4 flex items-center gap-3`}>
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl shrink-0">
                    <i className={`${mat.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h2 className="text-xl md:text-2xl font-bold text-white">{mat.category}</h2>
                    <p className="text-white/70 text-xs">{mat.items.length}가지 소재</p>
                  </div>
                  <span className="ml-auto text-white/60 text-xs font-medium">{mat.items.length} types</span>
                </div>

                {/* 이미지 갤러리 */}
                <div className="grid grid-cols-3 gap-0 h-40 md:h-52">
                  {mat.images.map((imgUrl, i) => (
                    <div key={i} className="overflow-hidden relative">
                      <img src={imgUrl} alt={`${mat.category} 소재 ${i + 1}`}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                      {i === 0 && (
                        <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent"></div>
                      )}
                    </div>
                  ))}
                </div>

                {/* 자재 아이템 목록 */}
                <div className="p-5 md:p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {mat.items.map((item, i) => (
                      <div key={i} className={`flex gap-3 p-4 rounded-xl bg-gray-50 border-l-4 ${mat.accentColor} hover:bg-orange-50/40 transition-colors`}>
                        <div className="shrink-0 mt-0.5">
                          <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-bold ${mat.tagColor} ${mat.tagText}`}>
                            {item.tag}
                          </span>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm md:text-base font-bold text-gray-900 mb-1">{item.name}</p>
                          <p className="text-xs md:text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 하단 CTA */}
        <section className="py-12 md:py-16 px-4 bg-gradient-to-br from-orange-50 to-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-3">원하시는 자재로 제작 문의하기</h3>
            <p className="text-sm md:text-base text-gray-500 mb-6">위 자재 외에도 다양한 소재 가공이 가능합니다. 언제든지 문의해 주세요.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button onClick={() => setShowContactModal(true)}
                className="px-8 py-3 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-colors shadow-lg whitespace-nowrap cursor-pointer text-sm md:text-base">
                견적 문의하기
              </button>
              <Link to="/"
                className="px-8 py-3 bg-white text-gray-700 font-bold rounded-lg hover:bg-gray-50 transition-colors border-2 border-gray-200 whitespace-nowrap cursor-pointer text-sm md:text-base text-center">
                홈으로 돌아가기
              </Link>
            </div>
          </div>
        </section>

        {/* 푸터 */}
        <footer className="bg-gray-900 text-white py-10 px-5">
          <div className="max-w-6xl mx-auto text-center">
            <img src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png" alt="NS-TECH Logo" className="h-10 w-auto mx-auto mb-4 brightness-0 invert" />
            <p className="text-gray-400 text-xs mb-1">© 2025 NS-TECH. All rights reserved.</p>
            <p className="text-gray-500 text-xs">경기도 포천시 소흘읍 소흘로 11 | Tel: 031-541-1902 | Email: nstech01@naver.com</p>
          </div>
        </footer>

        {/* 모바일 플로팅 전화 버튼 */}
        <a href="tel:031-541-1902"
          className="lg:hidden fixed bottom-24 right-4 z-50 flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white pl-3 pr-4 py-2.5 rounded-full shadow-xl transition-all active:scale-95 cursor-pointer"
          aria-label="전화 연결">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-fill text-white text-base"></i>
          </div>
          <span className="text-xs font-bold whitespace-nowrap">전화문의</span>
        </a>

        {/* 연락처 모달 */}
        {showContactModal && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setShowContactModal(false)}>
            <div className="bg-white rounded-3xl max-w-md w-full p-6 md:p-8 relative shadow-2xl" onClick={(e) => e.stopPropagation()}>
              <button onClick={() => setShowContactModal(false)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer" aria-label="닫기">
                <i className="ri-close-line text-gray-600 text-xl"></i>
              </button>
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-orange-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">견적 문의</h3>
                <p className="text-sm text-gray-500">편하신 방법으로 연락주세요</p>
              </div>
              <div className="space-y-3 mb-6">
                {[
                  { icon: 'ri-building-line', label: '회사명', value: 'NS-TECH' },
                  { icon: 'ri-phone-line', label: '전화번호', value: '031-541-1902' },
                  { icon: 'ri-printer-line', label: '팩스', value: '031-541-1903' },
                  { icon: 'ri-mail-line', label: '이메일', value: 'nstech01@naver.com' },
                  { icon: 'ri-time-line', label: '운영시간', value: 'AM 08:00 ~ PM 18:00' },
                ].map((info) => (
                  <div key={info.label} className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                    <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center shrink-0">
                      <i className={`${info.icon} text-orange-500`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">{info.label}</p>
                      <p className="text-base font-semibold text-gray-900">{info.value}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-3">
                <a href="tel:031-541-1902"
                  className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-medium transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line"></i><span>전화하기</span>
                </a>
                <a href="mailto:nstech01@naver.com"
                  className="flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white py-3 rounded-xl font-medium transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-mail-line"></i><span>메일보내기</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
